import * as config from 'config';
import lazysizes from 'lazysizes';

// ------------------------------------------------------------------------
// Let the markup know that JS was loaded
// ------------------------------------------------------------------------
document.documentElement.className = 'js';

// ------------------------------------------------------------------------
// Bugsnag
// ------------------------------------------------------------------------
// if (config.BUGSNAG_API_KEY_JS) {
//     require('boot/bugsnag');
// }


// ------------------------------------------------------------------------
// Polyfills
// ------------------------------------------------------------------------
require('boot/polyfills');


// ------------------------------------------------------------------------
// Lodash
// ------------------------------------------------------------------------
// window._ = require('lodash');


// ------------------------------------------------------------------------
// Vue
// ------------------------------------------------------------------------
require('boot/vue');


// ------------------------------------------------------------------------
// Lazysizes
// ------------------------------------------------------------------------
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

// require('lazysizes/plugins/object-fit/ls.object-fit.min');
// require('lazysizes/plugins/parent-fit/ls.parent-fit');
// require('lazysizes/plugins/unveilhooks/ls.unveilhooks.min');

document.addEventListener('AppReady', lazysizes.init);

// ------------------------------------------------------------------------
// Axios
// ------------------------------------------------------------------------
window.axios = require('axios');

// axios.defaults.baseURL = config.API_PREFIX
axios.defaults.headers.common = {
    // 'Authorization': 'Bearer ' + config.API_TOKEN,
    // 'X-CSRF-TOKEN': window.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
};


// ------------------------------------------------------------------------
// Tools
// ------------------------------------------------------------------------
require('boot/tools');
